export default __webpack_public_path__ + "static/cats-878febab76c87c9d402d0c89d3408f4d.gif";